// extracted by mini-css-extract-plugin
export var modal = "_iz-0";